import type { SVGProps } from "react";

const IconOnSelected = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="23"
        height="23"
        rx="11.5"
        fill="url(#paint0_linear_20064_2083)"
      />
      <path
        d="M18.643 5.95898C14.387 8.56998 11.3 11.867 9.907 13.519L6.505 10.852L5 12.063L10.873 18.041C11.881 15.451 15.087 10.39 19 6.79198L18.643 5.95898Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_20064_2083"
          x1="2.98547e-07"
          y1="1.4375"
          x2="20.8437"
          y2="21.2031"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5DE5E3" />
          <stop offset="0.506605" stopColor="#5297FF" />
          <stop offset="1" stopColor="#FC9DFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IconOnSelected;
